window.DASHBOARD_DRIVE_LIST = {
    options: {
        getFilteredDrivesURL: null,
    },
    init: function(options) {
        _.extend(window.DASHBOARD_DRIVE_LIST.options, options);
        window.DASHBOARD_DRIVE_LIST.initEventListeners();
        window.DASHBOARD_DRIVE_LIST.initDriveSelectButtons();
    },
    getCheckedDrives: function(){
        return $.map(
            $('#drive-check-list .form-check [type=checkbox]:checked'),
            function(o){ return $(o).val(); }
        ).sort(); // There is no defined order - so for now be consistent and lets sort by ID. Partly to make the tests easier :)
    },
    initEventListeners: function()
    {
        Livewire.on('dashboardShowDrive', function (drive) {
            window.DASHBOARD_DRIVES.showDrive(drive);
        });
        Livewire.on('dashboardHideDrive', function (drive) {
            window.DASHBOARD_DRIVES.hideDrive(drive);
        });
    },
    initDriveSelectButtons: function(){
        $('.drive-select-button').on('click', function(e){
            e.preventDefault();
            window.DASHBOARD_DRIVE_LIST.loadDrivesFromFilter($(this).data('action'));
        });
    },
    loadDrivesFromFilter: function(filter, params = [], checked = true){
        var url = window.DASHBOARD_DRIVE_LIST.options.getFilteredDrivesURL.replace(':filter', filter);
        axios.get(url, { params: params })
            .then(function(response){
                response.data.data.forEach(drive => {
                    // If we've not loaded the drive yet, load it up,
                    if ($(`#drive-check-list input[value=${drive.id}]`).length === 0) {
                        window.DASHBOARD_DRIVES.showDrive(drive);
                    } else {
                        // If we have - then just select it and trigger a change.
                        $(`#drive-check-list input[value=${drive.id}]`).prop('checked', 'checked').trigger('change');
                    }
                });
            }).catch(function(error) {
                console.log(error);
                alert('An error occured loading the drive, please refresh and try again or contact a developer.');
            });
    },
    onDriveCheckboxChange: function ($checkboxOrEvent) {
        return;

        // If we have an event, we were called from $.on(), if not we were called
        // directly and passed the checkbox.
        var $this = ($checkboxOrEvent.currentTarget)
            ? $(this)
            : $checkboxOrEvent;

        var driveId = $this.val();
        if($this.is(':checked')) {
            // Don't draw if we're already drawn
            if (
                (driveDashboard.showLines && driveDashboard.routingControls['drive_' + driveId] == undefined)
                || (driveDashboard.showDits && driveDashboard.driveDotLayers['drive_' + driveId] == undefined)
            ) {
                window.driveDashboard.drawDriveOnMap(driveId).then(function(){
                    // If we're not completed, listen for new waypoints.
                    if(driveDashboard['drive_' + driveId].status !== 'Completed') {
                        driveDashboard.listenForMoreWaypoints(driveId);
                    }
                });
            }
        } else {
            driveDashboard.removeDriveFromMap(driveId);
            driveDashboard.stopListeningForMoreWaypoints(driveId);
        }
    },
}
